import { IDX_DB_VALUE_KEYS, indexedDbStorage } from "@/utils/indexDBStorage";
import { createSelectorHooks } from "auto-zustand-selectors-hook";
import { produce } from "immer";
import { create } from "zustand";
import {
  persist,
  PersistStorage
} from "zustand/middleware";

interface IUserGuideSteps {
  [key: string]: {
    done: boolean;
  };
}

export interface payload {
  isLoadingUG: boolean;
  enabled: boolean;
  initial: number;
  which: string;
  steps: IUserGuideSteps;
}

interface IUGResult extends payload {
  setUG: (val: { enabled: boolean; initial: number }) => void;
  setDone: (val: { val: boolean; which: string }) => void;
  setInitial: (val: number) => void;
  reset: () => void;
  setLoadingUG: (val: boolean) => void;
}

const useUserGuideStore = create(
  persist<IUGResult>(
    (set) => ({
      enabled: false,
      initial: 0,
      isLoadingUG: true,
      which: "",
      steps: {
        goals: {
          done: false,
        },
        profile: {
          done: false,
        },
        highlightExpertise: {
          done: false,
        },
        connections: {
          done: false,
        },
        profileEmployee: {
          done: false,
        },
        hrDashboard: {
          done: false,
        },
        reportMentorship: {
          done: false,
        },
        reportConnection: {
          done: false,
        },
        reportMilestone: {
          done: false,
        },
        orgSettings: {
          done: false,
        },
        manageSkillLadder: {
          done: false,
        },
        manageSpecificSkill: {
          done: false,
        },
        panelRewards: {
          done: false,
        },
      },
      setUG(val) {
        set(
          produce<payload>((state) => {
            state.enabled = val.enabled;
            state.initial = val.initial;
          })
        );
      },
      setDone(val) {
        set(
          produce<payload>((state) => {
            if (state.steps?.[val.which]) {
              state.steps[val.which].done = val.val;
            }
          })
        );
      },
      setInitial(val: number) {
        set(
          produce<payload>((state) => {
            state.initial = val;
          })
        );
      },
      setLoadingUG(val: boolean) {
        set(
          produce<payload>((state) => {
            state.isLoadingUG = val;
          })
        );
      },
      reset() {
        set(
          produce<payload>((state) => {
            state.enabled = false;
            state.initial = 0;
            state.which = "";
            state.steps = {
              goals: {
                done: false,
              },
              profile: {
                done: false,
              },
              highlightExpertise: {
                done: false,
              },
              connections: {
                done: false,
              },
              profileEmployee: {
                done: false,
              },
              hrDashboard: {
                done: false,
              },
              reportMentorship: {
                done: false,
              },
              reportConnection: {
                done: false,
              },
              reportMilestone: {
                done: false,
              },
              orgSettings: {
                done: false,
              },
              manageSkillLadder: {
                done: false,
              },
              manageSpecificSkill: {
                done: false,
              },
              panelRewards: {
                done: false,
              },
            };
          })
        );
      },
    }),
    {
      name: IDX_DB_VALUE_KEYS.userGuide,
      storage: indexedDbStorage as unknown as PersistStorage<IUGResult>,
    }
  )
);

const useUserGuideStoreStore = createSelectorHooks(useUserGuideStore);

export default useUserGuideStoreStore;
